var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: props.fill,
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.812 7.814v12.315c0 .962-.78 1.742-1.741 1.742H3.24c-.961 0-1.741-.78-1.741-1.742V5.655a1.62 1.62 0 011.62-1.62h14.764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.591 17.035l-2.95.56a1.25 1.25 0 01-1.463-1.462l.56-2.952L19.925 1.992a1.682 1.682 0 012.377 0l1.477 1.477c.656.656.656 1.72 0 2.377L12.591 17.035zM8.738 13.181l3.854 3.855"
  }))));
}
export default SvgBlog;